<template>
  <div class="my-orders-page">
    <van-nav-bar title="我的订单" />

    <!-- 订单列表 -->
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadOrders"
        >
          <div v-for="order in orderList" :key="order.id" class="order-card" @click="goDetail(order)">
            <div class="order-header">
              <span class="order-no">{{ order.order_no }}</span>
              <span :class="['order-status', 'status-' + order.status]">
                {{ order.status_text }}
              </span>
              <span v-if="order.refund_status_text" class="refund-status">{{ order.refund_status_text }}</span>
            </div>
            <div class="order-body">
              <div class="order-image">
                <img :src="$common.polishingImg(order.cover_img)" :alt="order.tit" v-if="order.cover_img" />
                <div v-else class="placeholder-img">{{ order.tit ? order.tit[0] : '' }}</div>
              </div>
              <div class="order-info">
                <div class="order-tit">{{ order.tit }}</div>
                <div class="order-meta">
                  <span>{{ order.classify }}类</span>
                  <span>{{ order.reg_no }}</span>
                </div>
                <div class="order-type">{{ order.need_notary_text }}</div>
                <div class="order-price-wrap">
                  <div class="order-price">总价: ¥{{ formatPrice(order.selling_price) }}</div>
                  <div class="order-stage-price" v-if="order.need_notary === 1">
                    <span v-if="order.status === STATUS_PENDING" class="highlight">待付定金: ¥{{ formatPrice(order.deposit_amount) }}</span>
                    <span v-else-if="order.status === STATUS_NOTARIZED" class="highlight">待付尾款: ¥{{ formatPrice(order.final_amount) }}</span>
                    <span v-else-if="order.status === STATUS_COMPLETED" class="paid">交易完成</span>
                    <span v-else-if="order.pay_status === 2" class="paid">已付全款，待交接资料</span>
                    <span v-else-if="order.status === STATUS_CANCELLED" class="cancelled">已取消</span>
                    <span v-else>已付定金: ¥{{ formatPrice(order.deposit_amount) }}</span>
                  </div>
                  <div class="order-stage-price" v-else>
                    <span v-if="order.status === STATUS_PENDING" class="highlight">待付全款: ¥{{ formatPrice(order.selling_price) }}</span>
                    <span v-else-if="order.status === STATUS_COMPLETED" class="paid">交易完成</span>
                    <span v-else-if="order.pay_status === 2" class="paid">已付全款，待交接资料</span>
                    <span v-else-if="order.status === STATUS_CANCELLED" class="cancelled">已取消</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-footer">
              <span class="order-time">{{ order.created_at }}</span>
              <div class="order-actions">
                <van-button
                  v-if="order.status === STATUS_PENDING"
                  type="default"
                  size="small"
                  round
                  @click.stop="cancelOrder(order)"
                >
                  取消订单
                </van-button>
                <van-button
                  v-if="order.status === STATUS_PENDING"
                  type="danger"
                  size="small"
                  round
                  plain
                  :loading="payingOrderId === order.id"
                  @click.stop="goPay(order)"
                >
                  去支付
                </van-button>
                <van-button
                  v-if="canApplyRefund(order)"
                  type="warning"
                  size="small"
                  round
                  plain
                  @click.stop="applyRefund(order)"
                >
                  申请退款
                </van-button>
                <van-button
                  v-if="order.status === STATUS_NOTARIZED"
                  type="danger"
                  size="small"
                  round
                  :loading="payingOrderId === order.id"
                  @click.stop="goPayFinal(order)"
                >
                  支付尾款
                </van-button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <!-- 空状态 -->
      <div v-if="!loading && orderList.length === 0" class="empty-state">
        <!-- <div class="empty-icon">📦</div>
        <p>暂无订单</p> -->
        <van-button type="danger" round @click="goShopping">去逛逛</van-button>
      </div>
      <!-- 二维码弹窗 -->
      <van-popup v-model="showQrCode" round closeable position="center" class="qr-popup" @closed="stopPayPolling">
        <div class="qr-content">
          <div class="qr-title">请使用微信或支付宝扫码支付</div>
          <canvas id="qrCodeCanvas" class="qr-canvas"></canvas>
          <van-button plain round block style="margin-top: 16px;" @click="checkPayStatus(true)">
            支付完成
          </van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import stroe from '../store'
import QRCode from 'qrcode'
import { canApplyRefund } from '../constants/orderRefund'

const TAB_ORDERS_INDEX = 1

export default {
  name: 'MyOrdersPage',
  data() {
    return {
      STATUS_PENDING: 0,
      STATUS_NOTARIZED: 2,
      STATUS_COMPLETED: 4,
      STATUS_CANCELLED: 5,
      orderList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      payingOrderId: null,
      showQrCode: false,
      qrCodeUrl: '',
      currentPayOrderNo: '',
      currentPayOrderStatus: null,
      payTimer: null
    }
  },
  beforeDestroy() {
    this.stopPayPolling()
  },
  methods: {
    canApplyRefund,
    goShopping() {
      this.$router.push('/payment')
    },
    goDetail(order) {
      // 查看订单详情
      this.$router.push({
        path: '/order-detail',
        query: { order_id: order.id }
      })
    },
    async goPay(order) {
      // 去支付（首笔）
      let amount = 0
      let type = 'full'
      if (order.need_notary == 1) {
        amount = order.deposit_amount
        type = 'deposit'
      } else {
        amount = order.selling_price
        type = 'full'
      }
      await this.executePay(order.id, order.order_no, amount, type, order.status)
    },
    async goPayFinal(order) {
      // 支付尾款
      await this.executePay(order.id, order.order_no, order.final_amount, 'final', order.status)
    },
    async executePay(orderId, orderNo, amount, type, initialStatus) {
      this.payingOrderId = orderId
      try {
        const formData = new FormData()
        formData.append('order_no', orderNo)
        formData.append('amount', amount)
        formData.append('type', type)

        const res = await this.$common.cusHttp(
          this,
          '/api/saas_order.php?action=pay',
          formData,
          'post'
        )
        
        const data = JSON.parse(res.data)
        if (data.status) {
          const qrCodeUrl = data.data.qrCodeUrl
          const isWechat = /MicroMessenger/i.test(navigator.userAgent)
          
          if (isWechat) {
            window.location.href = qrCodeUrl
          } else {
            this.qrCodeUrl = qrCodeUrl
            this.currentPayOrderNo = orderNo
            this.currentPayOrderStatus = initialStatus
            this.showQrCode = true
            this.$nextTick(() => {
              this.generateQrCode()
              this.startPayPolling()
            })
          }
        } else {
          this.$toast.fail(data.desc || '支付失败，请重试')
        }
      } catch (err) {
        console.error('支付请求失败:', err)
        this.$toast.fail('网络错误，请重试')
      } finally {
        this.payingOrderId = null
      }
    },
    // 生成二维码
    generateQrCode() {
      const canvas = document.getElementById('qrCodeCanvas')
      if (canvas) {
        QRCode.toCanvas(canvas, this.qrCodeUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }, function (error) {
          if (error) console.error(error)
        })
      }
    },
    // 开始轮询支付状态
    startPayPolling() {
      this.stopPayPolling() // 确保没有重复的定时器
      this.payTimer = setInterval(() => {
        this.checkPayStatus(false)
      }, 3000) // 每3秒查一次
    },
    // 停止轮询
    stopPayPolling() {
      if (this.payTimer) {
        clearInterval(this.payTimer)
        this.payTimer = null
      }
    },
    // 检查支付状态
    async checkPayStatus(isManual = false) {
      if (!this.currentPayOrderNo) return

      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_order.php?action=check_pay_status&order_no=${this.currentPayOrderNo}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          const orderStatus = data.data.status
          // 如果订单状态和唤起支付时的状态不一样了，说明支付成功且状态流转了（或被取消）
          if (orderStatus !== this.currentPayOrderStatus) {
            this.stopPayPolling()
            this.showQrCode = false
            if (orderStatus !== this.STATUS_CANCELLED) {
              this.$toast.success('支付成功')
            }
            this.onRefresh()
            return
          }
        }
        
        // 如果是手动点击"支付完成"且还没支付成功，给个提示
        if (isManual) {
          this.$toast('暂未查询到支付结果，请稍后重试或确认是否已扣款')
        }
      } catch (err) {
        console.error('查询支付状态失败:', err)
      }
    },
    cancelOrder(order) {
      this.$dialog.confirm({
        title: '取消订单',
        message: '确定要取消该订单吗？',
      }).then(async () => {
        try {
          const formData = new FormData()
          formData.append('order_id', order.id)
          formData.append('status', this.STATUS_CANCELLED)
          
          const res = await this.$common.cusHttp(
            this,
            '/api/saas_order.php?action=update_status',
            formData,
            'post'
          )
          const data = JSON.parse(res.data)
          if (data.status) {
            this.$toast.success('订单已取消')
            // 刷新列表
            this.onRefresh()
          } else {
            this.$toast.fail(data.desc || '取消失败')
          }
        } catch (err) {
          console.error('取消订单失败:', err)
          this.$toast.fail('网络错误，取消失败')
        }
      }).catch(() => {
        // on cancel
      })
    },
    applyRefund(order) {
      const reason = window.prompt('请填写退款原因，提交后需代卖方或平台审核')
      if (reason === null) return
      const text = reason.trim()
      if (!text) {
        this.$toast.fail('请填写退款原因')
        return
      }

      const formData = new FormData()
      formData.append('order_id', order.id)
      formData.append('reason', text)

      this.$common.cusHttp(
        this,
        '/api/saas_order.php?action=apply_refund',
        formData,
        'post'
      ).then(res => {
        const data = JSON.parse(res.data)
        if (data.status) {
          this.$toast.success(data.desc || '退款申请已提交')
          this.onRefresh()
        } else {
          this.$toast.fail(data.desc || '申请失败')
        }
      }).catch(err => {
        console.error('申请退款失败:', err)
        this.$toast.fail('网络错误，请重试')
      })
    },
    // 加载订单列表
    async loadOrders() {
      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_order.php?action=order_list&page=${this.page}&pageSize=${this.pageSize}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          const list = data.data.list || []
          
          if (this.refreshing) {
            this.orderList = []
            this.refreshing = false
          }
          
          this.orderList.push(...list)
          this.page++

          if (list.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
          this.refreshing = false
        }
      } catch (err) {
        console.error('加载订单失败:', err)
        this.finished = true
        this.refreshing = false
      } finally {
        this.loading = false
      }
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true
      this.finished = false
      this.loading = true
      this.page = 1
      this.loadOrders()
    },
    // 格式化价格
    formatPrice(price) {
      if (!price || price <= 0) return '0'
      return Math.round(price).toLocaleString()
    }
  },
  mounted() {
    stroe.commit('setTarbarIndex', TAB_ORDERS_INDEX)
    
    // 检查是否有从下单页传过来的支付参数，如果有，自动弹起支付二维码
    const query = this.$route.query
    if (query.pay_order_no && query.qr_url) {
      this.currentPayOrderNo = query.pay_order_no
      this.currentPayOrderStatus = parseInt(query.pay_status || 0)
      this.qrCodeUrl = decodeURIComponent(query.qr_url)
      this.showQrCode = true
      this.$nextTick(() => {
        this.generateQrCode()
        this.startPayPolling()
      })
      
      // 清除 URL 参数，避免刷新页面再次弹起
      this.$router.replace({ path: '/my-orders' })
    }
  }
}
</script>

<style scoped>
.my-orders-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.order-list {
  padding: 12px;
}

.order-card {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
}

.order-no {
  font-size: 13px;
  color: #999;
}

.order-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

.order-status.status-0 { background: #fff7e6; color: #fa8c16; }
.order-status.status-1 { background: #e6f7ff; color: #2563eb; }
.order-status.status-2 { background: #f0f5ff; color: #2f54eb; }
.order-status.status-3 { background: #f6ffed; color: #52c41a; }
.order-status.status-4 { background: #f6ffed; color: #52c41a; }
.order-status.status-5 { background: #f5f5f5; color: #8c8c8c; }

.refund-status {
  margin-left: 8px;
  font-size: 12px;
  color: #fa8c16;
}

.order-body {
  display: flex;
  padding: 16px;
}

.order-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  flex-shrink: 0;
}

.order-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #999;
}

.order-info {
  flex: 1;
  margin-left: 12px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.order-tit {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.order-meta {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  display: flex;
  gap: 12px;
}

.order-type {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.order-price-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.order-price {
  font-size: 14px;
  color: #333;
}

.order-stage-price {
  font-size: 14px;
  font-weight: bold;
}

.order-stage-price .highlight {
  color: #ee0a24;
}

.order-stage-price .paid {
  color: #52c41a;
  font-weight: normal;
}

.order-stage-price .cancelled {
  color: #999;
  font-weight: normal;
}

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #f5f5f5;
}

.order-time {
  font-size: 12px;
  color: #999;
}

.order-actions {
  display: flex;
  gap: 8px;
}

.order-actions .van-button {
  padding: 0 16px;
  height: 28px;
  line-height: 26px;
  white-space: nowrap;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-state p {
  color: #999;
  margin-bottom: 24px;
}

/* 二维码弹窗 */
.qr-popup {
  width: 80%;
  max-width: 320px;
  padding: 24px;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qr-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}

.qr-canvas {
  width: 200px !important;
  height: 200px !important;
  margin: 0 auto;
}
</style>
